import {formattedPropertyModel} from '@wallaby-ui/core';
import {isNil} from 'lodash';

export default function baseIntegerFormatterParams(params) {
  const {value} = params;
  const propDefinition = new formattedPropertyModel.FormattedProperty({
    type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_INTEGER,
  });
  const formattedValue = !isNil(value)
    ? formattedPropertyModel.FormattedProperty.formatValue(
        propDefinition,
        value
      )
    : '';

  return {...params, formattedValue};
}
